<template>
  <svg :class="bemClass()">
    <use :xlink:href="iconId" />
  </svg>
</template>

<script>
import { computed, toRefs } from 'vue'
import useBem from '../../compositions/bem'

export default {
  name: 'SelIcon',
  props: {
    iconName: {
      type: String
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const { modifier } = toRefs(props)
    const { bemClass } = useBem('sel-icon', modifier)

    const iconId = computed(() => `#${props.iconName}`)

    return {
      bemClass,
      iconId
    }
  }
}
</script>

<style scoped>
.sel-icon {
  width: 16px;
  height: 16px;
}
</style>
